import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Header, NavHeader, Page } from '../../../../../../components';
import { ROUTES } from '../../../../../../routes/routes';
import { ActionType, TaskVariant } from '../../../../../../types/actions';
import { CentralActionDetailsChannels } from '../../../../components/central-action/details-channels';
import { useExalusCreateActionContext } from '../../context';
import { BlindSettings } from './channel-forms/blind';
import { DimSettings } from './channel-forms/dim';
import { FacadeSettings } from './channel-forms/facade';
import { GateSettings } from './channel-forms/gate';
import { MicroventilationSettings } from './channel-forms/microventilation';
import { OnOffSettings } from './channel-forms/on-off';
import { RGBWSettings } from './channel-forms/rgbw';

const ExalusActionChannelSettings: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('action');
  const { actionType, channels, taskVariant } = useExalusCreateActionContext();

  useEffect(() => {
    if (actionType === ActionType.Undefined) navigate(ROUTES.ActionList(), { replace: true });
  }, []);

  const renderCurrentView = () => {
    switch (taskVariant) {
      case TaskVariant.OnOff:
        return <OnOffSettings />;
      case TaskVariant.SetFacade:
        return <FacadeSettings />;
      case TaskVariant.SetMicrowave:
        return <MicroventilationSettings />;
      case TaskVariant.SetRGBW:
        return <RGBWSettings />;
      case TaskVariant.SetBlind:
        return <BlindSettings />;
      case TaskVariant.SetGate:
        return <GateSettings />;
      case TaskVariant.Dim:
        return <DimSettings />;
      default:
        return null;
    }
  };

  return (
    <Page
      isStickyHeader
      className="parameter-settings"
      header={
        <>
          <NavHeader />
          <Header title={t(`action.create.tasks.variants.${taskVariant}`)} />
        </>
      }
    >
      <div className="details-page">{renderCurrentView()}</div>
      <CentralActionDetailsChannels channels={channels} />
    </Page>
  );
};

export default ExalusActionChannelSettings;
